import {createRPRequestMeta} from "../common/app/rp_request_meta";

export const clientRpRequestMeta = createRPRequestMeta({});
import {createRPRequestMeta} from "../common/app/rp_request_meta";

export const clientRpRequestMeta = createRPRequestMeta({});
